<template>
  <a-card :bordered='false'>
    <div>
      <SmallSquare content="1、公众号群发在以下情况会出现发送不成功：（1）用户设置拒收；（2）用户当月已接收超过4条群发消息。
      2、在群发消息编辑过程中会存在新增关注或用户取关的情况，实际群发人数以群发结果为准。
      3、在定时群发任务待执行时，会存在新增关注或用户取关的情况，实际群发人数以群发结果为准。" />
    </div>
    <a-form class='m-t-30' ref="ruleForm" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" >
      <a-form-item label="群发对象" required>
        <a-radio-group v-model:value="form.resource">
          <a-radio :value="1">全部粉丝</a-radio>
          <a-radio :value="2">指定会员等级</a-radio>
          <a-radio :value="3">指定粉丝标签</a-radio>
        </a-radio-group>
        <div class="m-t-15">
          <a-select v-if='form.resource == 2' v-model:value="form.level" mode="multiple" style="width: 100%" placeholder="请选择会员等级" :options="memberLevel" @change="handleChange" option-label-prop="id"></a-select>
          <a-select v-if='form.resource == 3' v-model:value="form.level" mode="multiple" style="width: 100%" placeholder="请选择粉丝标签" :options="memberLevel" @change="handleChange" option-label-prop="id"></a-select>
          <p class="s_c999" v-if='form.resource !== 1'>当前人数123人，实际可接收人数100 个</p>
        </div>
      </a-form-item>
      <a-form-item label="消息内容" required>
        <a-tabs v-model:activeKey='activeKey'>
          <a-tab-pane :key="1">
            <template #tab>
              <span>
                <EditOutlined />文字
              </span>
            </template>
            <addReply></addReply>
          </a-tab-pane>
          <a-tab-pane :key="2">
            <template #tab>
              <span>
                <PictureOutlined />图片
              </span>
            </template>
            <msgReply></msgReply>
          </a-tab-pane>
          <template #tabBarExtraContent v-if='activeKey == 1'>
            <div class="s_flex_ali">
              <p class="s_c666 m-r-10">{{title}}</p>
              <a-tooltip>
                <template #title>
                  {{qpText}}
                </template>
                <QuestionCircleOutlined class="s_c376" />
              </a-tooltip>
            </div>
          </template>
        </a-tabs>
        <div class="" v-if='activeKey == 1'>
          <a-textarea v-model:value="form.text" showCount :maxlength="300" :rows='8' placeholder='请输入' />
        </div>
        <div class="s_flex_di" v-if='activeKey == 2'>
          <div class="imgTextBox s_flex_center width49 s_po_re">
            <img v-if='form.image_detail.file_url' class="width100" style="height: 100%;"
              :src="form.image_detail.file_url.indexOf(info.picdomain) == -1 ? info.picdomain+'/'+form.image_detail.file_url : form.image_detail.file_url"
              alt="">
            <div class="text-ac" v-if='!form.image_detail.file_url'>
              <PlusOutlined class="s_c999 fz-40" />
              <p class="s_c999">从素材库中选择</p>
            </div>
            <div class="s_po_ab_tl s_tou" v-if='!form.image_detail.file_url'>
              <wxMaterial :size='{width:621,height:250}' :groupType='1' :image="form.image_detail.file_url" :max="1"
                v-on:handlechoose="(data)=>{form.image_detail.file_url=data.imageUrl;form.image=data.data.media_id;}"
                v-on:handledel="form.image='';form.image_detail.file_url=''" />
            </div>
          </div>
          <a-button type="link" v-if='form.image_detail.file_url' @click="()=>{form.image='';form.image_detail.file_url=''}">
            删除</a-button>
        </div>
      </a-form-item>
      <!-- 发送时间 -->
      <a-form-item label="发送时间" required>
        <a-radio-group v-model:value="form.type">
          <a-radio :value="1">立即发送</a-radio>
          <a-radio :value="2">定时发送</a-radio>
        </a-radio-group>
        <div v-if='form.type==2'>
          <a-time-picker style='width:168px' showNow v-model:value="form.strValue" value-format="HH:mm:ss"
            placeholder='请选择发送时间' />
        </div>
      </a-form-item>
      <a-form-item class="text-ac">
        <a-button type="primary" @click='searchTable' class="m-r-26">保存</a-button>
        <a-button @click='searchTable'>返回</a-button>
      </a-form-item>
    </a-form>
    <a-modal  :keyboard="false" title="选择图文" :width='1300' centered :footer="null" v-model:visible="graphicVisible" destroyOnClose>
      <graphic v-on:success='success' v-on:cancel='graphicVisible = false' />
    </a-modal>
  </a-card>
</template>
<script>
  import { EditOutlined, PictureOutlined, QuestionCircleOutlined, PlusOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  let defForm = {
    name: '',
    resource:1,
    content: '',
    checked: false,
    strValue: '',
    level: [],
    type:1,
    text: '',
    image: '',
    graphic: {},
    image_detail: {},
    graphic_detail: {}
  }
  export default {
    components: { EditOutlined, PictureOutlined, QuestionCircleOutlined, PlusOutlined },
    setup() {
      const form = ref({ ...defForm });
      const state = reactive({
        labelCol: { span: 3 },
        wrapperCol: { span: 15 },
        graphicVisible: false,
        info: store.state.user.info,
        activeKey: 1,
        title: '文字回复可以用标签 <#微信昵称#> 显示会员微信昵称哦~',
        qpText: '后台设置：<#微信昵称#>终于等到你！ 用户关注后：高大永恒塑料制品有限公司后台 终于等到你！',
      });
      //选择图文
      const success = (e) => {
        form.value.graphic_detail = e
        form.value.graphic = {
          graphic_type: e.media_id ? 1 : 2,
          graphic_id: e.id
        }
        state.graphicVisible = false
      }
      return {
        ...toRefs(state),
        form,
        success
      };
    },
  };
</script>

<style lang="less" scoped>

  .imgTextBox {
    height: 250px;
    border: 1px dashed #e7e7eb;
    cursor: pointer
  }

  .imgTextBox:hover {
    border: 1px dashed #05486A;
  }
</style>